import { LookerAiEngagementDashboard } from './sections/AiEngagement/LookerAiEngagementDashboard';
import { LookerAiImpactDashboard } from './sections/AiImpact/LookerAiImpactDashboard';
import { LookerAiSatisfactionDashboard } from './sections/AiSatisfaction/LookerAiSatisfactionDashboard';
import { LookerCoDevHubsDashboard } from './sections/CoDevHubs/LookerCoDevHubsDashboard';
import { LookerCompanionDashboard } from './sections/Companion/LookerCompanionDashboard';
import { LookerEngagementDashboard } from './sections/Engagement/LookerEngagementDashboard';
import LookerImpactDashboard from './sections/Impact/LookerImpactDashboard';
import ImpactPlusDashboard from './sections/ImpactPlus/ImpactPlusDashboard';
import { LookerInsightsPlusDashboard } from './sections/InsightsPlus/LookerInsightsPlusDashboard';
import { LookerLearningDashboard } from './sections/Learning/LookerLearningDashboard';
import { LookerMRFDashboard } from './sections/MultiRaterFeedback/LookerMRFDashboard';
import { LookerOverviewDashboard } from './sections/Overview/LookerOverviewDashboard';
import { LookerSatisfactionDashboard } from './sections/Satisfaction/LookerSatisfactionDashboard';
import { LookerSurveyResultsDashboard } from './sections/SurveyResults/LookerSurveyResultsDashboard';
import { AISectionIds, SectionIds } from './utils/dashboardSideBar';

import { useFlags } from '~/lib/featureFlags';

export const DashboardSections = ({ currentSectionIndex }: { currentSectionIndex: string }) => {
  const {
    showMultiRaterFeedbackPage,
    showInsightsPlus,
    showCoDevHubsPage,
    showImpactPlus,
    showLearningPage,
    showCompanionPage,
    showSurveyResultsPage,
  } = useFlags();


  switch (currentSectionIndex) {
    case SectionIds.OVERVIEW:
      return <LookerOverviewDashboard />;
    case SectionIds.ENGAGEMENT:
      return <LookerEngagementDashboard />;
    case SectionIds.IMPACT:
      return <LookerImpactDashboard />;
    case SectionIds.SATISFACTION:
      return <LookerSatisfactionDashboard />;
    case SectionIds.MULTI_RATER_FEEDBACK:
      return showMultiRaterFeedbackPage ? <LookerMRFDashboard /> : null;
    case SectionIds.INSIGHTSPLUS:
      return <>{showInsightsPlus ? <LookerInsightsPlusDashboard /> : <></>}</>;
    case SectionIds.CODEVHUBS:
      return showCoDevHubsPage ? <LookerCoDevHubsDashboard /> : null;
    case SectionIds.IMPACTPLUS:
      return showImpactPlus ? <ImpactPlusDashboard /> : null;
    case SectionIds.LEARNING:
      return showLearningPage ? <LookerLearningDashboard /> : null;
    case SectionIds.COMPANION:
      return showCompanionPage ? <LookerCompanionDashboard /> : null;
    case SectionIds.SURVEY_RESULTS:
      return showSurveyResultsPage ? <LookerSurveyResultsDashboard /> : null;
    case AISectionIds.AI_SATISFACTION:
      return <LookerAiSatisfactionDashboard />;
    case AISectionIds.AI_ENGAGEMENT:
      return <LookerAiEngagementDashboard />;
    case AISectionIds.AI_IMPACT:
      return <LookerAiImpactDashboard />;
    default:
      return <LookerOverviewDashboard />;
  }
};
